<template>
    <div class="page1">
        <EButton type="primary" @click="dialogVisible=true">增加</EButton>
        <ETable :tableTitle="tableTitle" :tableData="tableData" :needPagination="false">
            <el-table-column fixed="right" label="操作" width="180px">
                <template slot-scope="scope">
                    <div>
                        <EButton type="text" @click="showDialog(scope.row)">
                            修改
                        </EButton>
                        <EButton type="text" @click="remove(scope.row)">
                            删除
                        </EButton>
                        <EButton type="text" @click="change(scope.row.placeId,scope.row.status)">
                            {{scope.row.status==1?'禁用':'启用'}}
                        </EButton>
                    </div>
                </template>
            </el-table-column>
        </ETable>
        <EDialog :dialogVisible="dialogVisible" :title="dialogForm.placeId?'修改位置':'新增位置'" @handleClose="cancelDialog"
                 width="30%" @handleClick="saveData(dialogForm.placeId)"
                 :disabled="saveDisabled"
                 @open="changeInfo(1)">
            <EForm :formColumns="dialogFormColumns" :rowSize="1" :optionsBtn="false" :actionBtn="false"
                   :formData="dialogForm" ref="form" :searchFlag="false" :labelPosition="labelPosition"
                   :labelWidth="labelWidth" :formRules="formRules">
            </EForm>
        </EDialog>
    </div>
</template>

<script>
  import ETable from '@/components/ETable'
  import Http from "@/service/http";
  import EDialog from '@/components/EDialog'
  import EButton from '@/components/EButton'
  import EForm from '@/components/EForm'
  import {identity_type, status} from '@/assets/js/config'
  import vxRule from "@/assets/js/formValidate";
  import {otherMixin} from "@/components/mixin";
  export default {
    name: 'location',
    mixins:[otherMixin],
    data() {
      return {
        tableTitle: [
          //{
          //  label: '区域名称',
          //  prop: 'areaName'
          //},
          {
            label: '位置名称',
            prop: 'placeName'
          },
          {
            label: '新建时间',
            prop: 'createTime'
          },
          {
            label: '新建人',
            prop: 'createUserCn'
          },
          {
            label: '最近一次修改时间',
            prop: 'updateTime',
          },
          {
            label: '修改人',
            prop: 'updateUserCn',
          },
          {
            label: '状态',
            prop: 'statusCn'
          },
        ],
        tableData: [],
        searchForm: {},
        count: null,
        dialogFormColumns: [
          {
            title: '区域：',
            type: 'select',
            property: 'areaId',
            placeHolder: '请选择',
            show: true,
            options: [],
            checkStrictly: false
          },
          {
            title: '位置名称',
            type: 'text',
            property: 'placeName',
            placeHolder: '最多可录入20字',
            show: true,
          },
        ],
        exportData: {},
        dialogVisible: false,
        labelPosition: 'right',
        labelWidth: '100px',
        formRules: {
          areaId: vxRule(true, '', "change", "区域不能为空"),
          placeName: vxRule(true, '', "blur", "位置名称不能为空"),
        },
        dialogForm: {
          areaId: '',
          placeName: '',
          placeId: ''
        },
        options: [],
        status:null//区域的筛选
      }
    },
    watch: {},
    created() {
      this.getData()
      this.getAreaLabel()
    },
    components: {ETable, EDialog, EButton, EForm},
    beforeMount() {

    },
    methods: {
      changeInfo(status){
        this.status=status
        this.getAreaLabel()
      },
      //获取区域下拉
      async getAreaLabel() {
        let res = await Http.getAreaLabel({
          status:this.status
        })
        if (res.code == 200) {
          this.dialogFormColumns[0].options = res.data
        }
      },
      async changeStatus(id, status) {
        let res = await Http.cmplaceUpdStatus({id, status})
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.getData()
        }
      },
      change(id, status) {
        let msg = ''
        if (status == 1) {
          msg = '禁用'
        } else {
          msg = '启用'
        }
        this.$messageBox.confirm('确定' + msg + '？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(res => {
          this.changeStatus(id, status == 1 ? 0 : 1)
        }).catch(res => {

        });
      },
      cancelDialog() {
        this.dialogVisible = false
        this.dialogForm = {
          placeName: '',
        }
        this.changeInfo(null)
        this.$refs.form.$refs.form.resetFields()
      },
      showDialog(row) {
        this.dialogVisible = true
        this.dialogForm.areaId = row.areaId
        this.dialogForm.placeName = row.placeName
        this.dialogForm.placeId = row.placeId
      },
      // 发送弹窗请求
      saveData(placeId) {
        this.$refs['form'].$refs['form'].validate((valid, object) => {
          console.log(object)
          if (valid) {
            this.locationSubmit(placeId)
          } else {
            return false;
          }
        });
      },
      //获取列表数据
      async getData() {
        let res = await Http.getLocationList()
        if (res.code == 200) {
          this.tableData = res.data
        }
      },
      //新增或者修改请求
      async locationSubmit(placeId) {
        this.setDisabled(true)
        let params = {
          placeName: this.dialogForm.placeName,
          areaId: this.dialogForm.areaId,
        }
        if (placeId) {
          params.placeId = placeId
        }
        let res = await Http.locationSubmit(params)
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.dialogVisible = false
          this.setDisabled(false)
          this.cancelDialog()
          this.getData()
        }
      },
      remove(row) {
        this.$messageBox.confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.locationRemove(row.placeId)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      async locationRemove(placeId) {
        let res = await Http.locationRemove({ids: placeId})
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.getData()
        }
      },
    }
  }
</script>

<style lang="scss">
</style>
